import _ from 'lodash';
import { create } from 'zustand';

export type ProjectRetrospectivesStore = {
  retrospectivesState: {
    [companyId: string]: {
      [projectId: string]: {
        [phase: string]: {
          expandedCategories: string[];
        };
      };
    };
  };
  projectRetrospectivesState: {
    [companyId: string]: {
      [projectId: string]: {
        [phase: string]: {
          expandedCategories: string[];
        };
      };
    };
  };
  setExpandedCategories: (options: {
    expandedCategories: string[];
    companyId: string;
    projectId: string;
    phase: string;
    type: 'retrospectivesState' | 'projectRetrospectivesState';
  }) => void;
};

const useRetrospectivesStore = create<ProjectRetrospectivesStore>()((set) => ({
  retrospectivesState: {},
  projectRetrospectivesState: {},
  setExpandedCategories: ({ companyId, projectId, phase, expandedCategories, type }) =>
    set((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [companyId]: {
          ...prevState?.[type]?.[companyId],
          [projectId]: {
            ...prevState?.[type]?.[companyId]?.[projectId],
            [phase]: {
              ...prevState?.[type]?.[companyId]?.[projectId]?.[phase],
              expandedCategories,
            },
          },
        },
      },
    })),
}));

export default useRetrospectivesStore;
